import React from 'react';

import UserList from './UserList';

import classes from './UserPage.module.css';


const TableContainer = ({
    setSelectedUser,
    userAction,
    setUserAction,
    ...props
}) => {

    return (
        <div className={classes.TableContainer}>
            <div className={classes.GridContainer}>
                <UserList
                    setSelectedUser={setSelectedUser}
                    userAction={userAction}
                    setUserAction={setUserAction}
                />
            </div>
        </div>
    );
};

export default TableContainer;
